import s from "./ghl-ui.es373.js";
function h(t, a) {
  return function(r, u) {
    if (r == null)
      return r;
    if (!s(r))
      return t(r, u);
    for (var f = r.length, e = a ? f : -1, n = Object(r); (a ? e-- : ++e < f) && u(n[e], e, n) !== !1; )
      ;
    return r;
  };
}
export {
  h as default
};
